<template>
  <div class="filter-popover-wrap" v-click-outside="closePopover">
    <div id="mfp-popover" v-show="show">
      <div class="mfp-arrow"></div>
      <div class="mfp-body">

        <!-- Tipo compensación -->
        <div class="mfp-section">
          <div class="mfp-label">{{ $t('creator.typeCompentation') }}</div>
          <div class="mfp-pills">
            <div
              class="mfp-pill"
              :class="{ active: compensation_type === 'fixed' }"
              @click="toggleCompensationType('fixed')"
            >{{ $t('creator.fixedShort') }}</div>
            <div
              class="mfp-pill"
              :class="{ active: compensation_type === 'negotiable' }"
              @click="toggleCompensationType('negotiable')"
            >{{ $t('creator.negotiableShort') }}</div>
          </div>
        </div>

        <!-- Rango -->
        <div class="mfp-section">
          <div class="mfp-label">{{ $t('creator.compesationRange') }}</div>
          <vue-slider
            class="mfp-slider"
            v-model="compensation_range"
            :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :max="10000"
            :min="10"
            :interval="1"
            :tooltip-formatter="formatter_commas"
          />
          <div class="mfp-range-row">
            <div class="mfp-input-wrap">
              <label>{{ $t('creator.min') }}</label>
              <cleave :options="options_cleave.number" v-model="compensation_range[0]" class="mfp-input" />
            </div>
            <div class="mfp-input-wrap">
              <label>{{ $t('creator.max') }}</label>
              <cleave :options="options_cleave.number" v-model="compensation_range[1]" class="mfp-input" />
            </div>
          </div>
        </div>

        <!-- Búsqueda por texto -->
        <div class="mfp-section">
          <div class="mfp-label">{{ $t('creator.searchText') }}</div>
          <input
            class="mfp-input"
            v-model="query"
            :placeholder="$t('creator.searchTextPlaceholder')"
            @keyup.enter="sendFilters"
          />
        </div>

        <!-- Pago -->
        <div class="mfp-section">
          <div class="mfp-label">{{ $t('creator.compensationPayout') }}</div>
          <div class="mfp-chips">
            <div
              v-for="compensation in $t('creator.compensations_type')"
              :key="compensation.value"
              class="mfp-chip"
              :class="{ active: compensation_payout.includes(compensation.value) }"
              @click="togglePayout(compensation.value)"
            >{{ compensation.text }}</div>
          </div>
        </div>

      </div>

      <div class="mfp-footer">
        <button class="mfp-btn-clear" @click="clearFilters">{{ $t('creator.clearFilter') }}</button>
        <button class="mfp-btn-apply" @click="sendFilters">{{ $t('creator.filterButton') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import cleave from 'vue-cleave-component';
import { separatebycomma } from '@/libs/utils/formats';

export default {
  name: 'filterSearchCastingCall',
  components: { VueSlider, cleave },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el._clickOutside = (e) => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener('click', el._clickOutside, true);
      },
      unbind(el) { document.removeEventListener('click', el._clickOutside, true); },
    },
  },
  props: {
    open_modal: { type: Boolean, default: false },
    update_key: { type: Boolean },
    filters_layout: { type: Array },
  },
  data() {
    return {
      options_cleave: { number: { numeral: true, numeralThousandsGroupStyle: 'thousand' } },
      compensation_type: null,
      compensation_range: ['10', '10000'],
      compensation_payout: [],
      query: '',
      show: false,
      formatter_commas: v => `${separatebycomma(v)}`,
      filters: [
        { filter: 'compensation_type', text: 'compensation_type', models: [{ name: 'compensation_type', value: null, default: null }] },
        { filter: 'compensation_range', text: 'compensation_range', models: [{ name: 'compensation_range', value: null, default: ['10', '10000'] }] },
        { filter: 'compensation_payout', text: 'compensation_payout', models: [{ name: 'compensation_payout', value: null, default: [] }] },
        { filter: 'query', text: 'query', models: [{ name: 'query', value: null, default: '' }] },
      ],
    };
  },
  created() {
    this.putFiltersUsedMarked();
  },
  methods: {
    closePopover() { this.show = false; },
    toggleCompensationType(val) {
      this.compensation_type = this.compensation_type === val ? null : val;
    },
    togglePayout(val) {
      const idx = this.compensation_payout.indexOf(val);
      if (idx === -1) this.compensation_payout.push(val);
      else this.compensation_payout.splice(idx, 1);
    },
    putFiltersUsedMarked() {
      if (this.filters_layout && this.filters_layout.length > 0) {
        this.filters = this.filters_layout;
        this.filters.forEach(fil => {
          const model = fil.models.find(m => m.name === fil.filter);
          if (model && model.value !== null) this[fil.filter] = model.value;
        });
      }
    },
    clearFilters() {
      this.filters.forEach(fil => {
        fil.models.forEach(item => {
          this[item.name] = item.default;
          item.value = null;
        });
      });
      this.$emit('filter', this.getFilters(), this.checkFiltersUsed().length, []);
      this.show = false;
    },
    changeFilter(name_filter, new_models) {
      const filter = this.filters.find(item => item.filter === name_filter);
      filter.models.forEach(model => {
        const nm = new_models.find(m => m.name === model.name);
        if (nm) model.value = nm.value;
      });
    },
    getFilters() {
      return {
        type_compensation: this.compensation_type || undefined,
        query: this.query && this.query.trim() ? this.query.trim() : undefined,
        amount_min: this.compensation_range[0] !== '10' ? this.compensation_range[0] : undefined,
        amount_max: this.compensation_range[1] !== '10000' ? this.compensation_range[1] : undefined,
        compensations: this.compensation_payout.length > 0 ? this.compensation_payout : undefined,
      };
    },
    checkFiltersUsed() { return this.filters.filter(item => item.models[0].value !== null); },
    sendFilters() {
      if (this.filters[3].models[0].value !== null && this.filters[3].models[0].value.length === 0) this.filters[3].models[0].value = null;
      if (this.filters[2].models[0].value !== null && this.filters[2].models[0].value.length === 0) this.filters[2].models[0].value = null;
      this.$emit('filter', this.getFilters(), this.checkFiltersUsed().length, this.filters);
      this.show = false;
    },
  },
  watch: {
    open_modal: { immediate: true, handler(val) { this.show = val; } },
    compensation_type(val) {
      this.changeFilter('compensation_type', [{ name: 'compensation_type', value: val || null }]);
    },
    compensation_range(val) {
      const changed = JSON.stringify(val) !== JSON.stringify(['10', '10000']);
      this.changeFilter('compensation_range', [{ name: 'compensation_range', value: changed ? val : null }]);
    },
    compensation_payout(val) { this.changeFilter('compensation_payout', [{ name: 'compensation_payout', value: val }]); },
    query(val) { this.changeFilter('query', [{ name: 'query', value: val && val.trim() ? val : null }]); },
  },
};
</script>

<style scoped>
.filter-popover-wrap {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1050;
  margin-top: 10px;
}

#mfp-popover {
  width: 500px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #ece9fd;
  box-shadow: 0 8px 32px rgba(115, 103, 240, 0.15), 0 2px 8px rgba(0, 0, 0, 0.06);
  font-family: 'Avenir', -apple-system, sans-serif;
}

.mfp-arrow {
  position: absolute;
  top: -7px;
  right: 24px;
  width: 13px;
  height: 13px;
  background: #fff;
  border: 1px solid #ece9fd;
  border-right: none;
  border-bottom: none;
  transform: rotate(45deg);
}

.mfp-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
  padding: 20px 20px 16px;
}

.mfp-section {}

.mfp-label {
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #bbb;
  margin-bottom: 8px;
}

/* Pills */
.mfp-pills { display: flex; gap: 7px; }
.mfp-pill {
  flex: 1;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1.5px solid #e8e8f0;
  font-size: 12px;
  font-weight: 600;
  color: #777;
  background: #fff;
  cursor: pointer;
  transition: all 0.13s;
  text-align: center;
  user-select: none;
}
.mfp-pill:hover { border-color: #7367f0; color: #7367f0; }
.mfp-pill.active { background: #7367f0; border-color: #7367f0; color: #fff; }

/* Slider */
.mfp-slider { margin: 4px 0 10px; }
.mfp-range-row { display: flex; gap: 8px; }
.mfp-input-wrap { flex: 1; }
.mfp-input-wrap label { font-size: 10px; color: #bbb; display: block; margin-bottom: 3px; }
.mfp-input {
  width: 100%;
  padding: 5px 9px;
  border: 1.5px solid #e8e8f0;
  border-radius: 7px;
  font-size: 12px;
  color: #444;
  outline: none;
}
.mfp-input:focus { border-color: #7367f0; }

/* Tags */
.mfp-tags-box {
  border: 1.5px solid #e8e8f0;
  border-radius: 9px;
  padding: 5px 9px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-height: 36px;
  align-items: center;
  cursor: text;
}
.mfp-tag {
  background: #f0eeff;
  color: #7367f0;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
}
.mfp-tag-x { cursor: pointer; opacity: 0.6; font-size: 13px; line-height: 1; }
.mfp-tag-x:hover { opacity: 1; }
.mfp-tag-input {
  border: none;
  outline: none;
  font-size: 12px;
  color: #444;
  flex: 1;
  min-width: 80px;
  background: transparent;
}

/* Chips */
.mfp-chips { display: flex; flex-wrap: wrap; gap: 5px; }
.mfp-chip {
  padding: 4px 10px;
  border-radius: 7px;
  border: 1.5px solid #e8e8f0;
  font-size: 11px;
  font-weight: 600;
  color: #777;
  cursor: pointer;
  background: #fff;
  transition: all 0.13s;
  user-select: none;
}
.mfp-chip:hover { border-color: #7367f0; color: #7367f0; }
.mfp-chip.active { background: #f0eeff; border-color: #7367f0; color: #7367f0; }

/* Footer */
.mfp-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px 16px;
  border-top: 1px solid #f3f3f8;
}
.mfp-btn-clear {
  padding: 7px 18px;
  border: 1.5px solid #e8e8f0;
  border-radius: 8px;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  color: #aaa;
  cursor: pointer;
  transition: all 0.13s;
}
.mfp-btn-clear:hover { border-color: #bbb; color: #666; }
.mfp-btn-apply {
  padding: 7px 24px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #7367f0, #9e95f5);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(115, 103, 240, 0.3);
  transition: opacity 0.13s;
}
.mfp-btn-apply:hover { opacity: 0.9; }
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-slider.scss';
</style>
